import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Carousel from 'react-multi-carousel';
import { CalendarDays } from 'lucide-react';
import 'react-multi-carousel/lib/styles.css';
import { format } from 'date-fns';
import { useNavigate } from 'react-router-dom';
import { fetchAllNews } from '../../Services/NewsService';
import Image from '../Image';

const NewsCarousel = () => {
  const [newsUpdates, setNewsUpdates] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (newsUpdates.length === 0) {
      getNews();
    }
  }, [newsUpdates]);

  const getNews = async () => {
    await fetchAllNews(setNewsUpdates);
  }

  const handleCardClick = (id) => {
    navigate(`/news/${id}`);
  };


  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1024 },
      items: 5
    },
    desktop: {
      breakpoint: {
        max: 3000,
        min: 1024
      },
      items: 3,
      partialVisibilityGutter: 40
    },
    mobile: {
      breakpoint: {
        max: 464,
        min: 0
      },
      items: 1,
      partialVisibilityGutter: 30
    },
    tablet: {
      breakpoint: {
        max: 1024,
        min: 464
      },
      items: 2,
      partialVisibilityGutter: 30
    }
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 ">
      <div className="bg-white shadow sm:rounded-lg m-6">
        <div className="px-4 py-3 sm:p-6">

          <Carousel responsive={responsive}
            additionalTransfrom={0}
            arrows
            autoPlay
            autoPlaySpeed={1500}
            centerMode={false}
            containerClass="container-with-dots"
            dotListClass=""
            draggable
            focusOnSelect={false}
            infinite
            itemClass="ps-4 pt-4"
            keyBoardControl
            minimumTouchDrag={80}
            pauseOnHover
            renderArrowsWhenDisabled={false}
            renderButtonGroupOutside={false}
            renderDotsOutside={false}
            className="mt-1">
            {newsUpdates && newsUpdates.map((news, index) => (
              <div key={index} className="cursor-pointer" onClick={() => handleCardClick(news.id)}>
                <Image
                  id={news.file_id}
                  className="w-full h-48 object-cover rounded-lg" />
                <div className="text-sm font-medium text-gray-900 my-2">
                  <Link to={`/news/${news.id}`}>{news.title}
                  </Link>
                </div>
                <p className="text-sm text-gray-500 inline-block">
                  <span className="flex items-center gap-1">
                    <CalendarDays className='w-4 h-4' />{news.event_date ? format(new Date(news.event_date), 'dd-MM-yyyy') : 'Date not available'}
                  </span>
                </p>
              </div>
            ))}
          </Carousel>
        </div>
      </div>
      <div className="flex justify-center">
        <Link to='/news'
          className="bg-blue-500 text-white px-4 py-2 rounded-md shadow-md hover:bg-blue-600"
        >
          See All News Updates
        </Link>
      </div>
    </div>
  );
};

export default NewsCarousel;
